// components/payments/PaymentStatusModal.tsx
import React from 'react';
import { Modal, Spin } from 'antd';
import styled, { keyframes } from 'styled-components';
import {FspType} from '@/shared/api/model';

const pulse = keyframes`
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(0, 0, 0, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); }
`;

const AnimatedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
`;

const PulsingCircle = styled.div`
  background: rgba(24, 144, 255, 0.7);
  border-radius: 50%;
  height: 100px;
  width: 100px;
  animation: ${pulse} 2s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #ffffff;
  }
`;

const MessageContainer = styled.div`
  margin-top: 20px;
  text-align: center;
`;

interface PaymentStatusModalProps {
    open: boolean;
    fspType?: FspType;
}

export const PaymentStatusModal: React.FC<PaymentStatusModalProps> = ({ open }) => {

    return (
        <Modal
            open={open}
            footer={null}
            closable={false}
            centered
        >
            <AnimatedContainer>
                <PulsingCircle>
                    <StyledSpin size="large" />
                </PulsingCircle>
                <MessageContainer>
                    <h3>Processing Your Payment</h3>
                    <p>Please check your phone for the payment prompt.</p>
                    <p>Don't close this window or refresh the page.</p>
                </MessageContainer>
            </AnimatedContainer>
        </Modal>
    );
};